import { render, staticRenderFns } from "./AdOfMonth.vue?vue&type=template&id=9a487ae0"
import script from "./AdOfMonth.vue?vue&type=script&lang=js"
export * from "./AdOfMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports